import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import entityComposition from '../../common/classes/entityComposition';
import { enabledSelector, labelSelector, newPathSelector, valueSelector } from '../selectors';
import { UncomposedSinglePickerField } from './singlePickerField';
import logValueOnChange from '../commonActions/logValueOnChange';
const ReportPickerField = _ref => {
  let label = _ref.label,
    enabled = _ref.enabled,
    job = _ref.job,
    onChange = _ref.onChange,
    _ref$reportReferenceA = _ref.reportReferenceActions,
    indexCancel = _ref$reportReferenceA.indexCancel,
    serverFilter = _ref$reportReferenceA.serverFilter,
    showCancel = _ref$reportReferenceA.showCancel,
    serverShow = _ref$reportReferenceA.serverShow,
    _ref$reportReference = _ref.reportReference,
    indexQuery = _ref$reportReference.indexQuery,
    active = _ref$reportReference.active,
    reports = _ref$reportReference.list,
    reportType = _ref.reportType,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? null : _ref$value,
    thisPath = _ref.thisPath;
  const reportsWithTitles = reports.map(r => ({
    id: r.id,
    title: "".concat(r.reportTypeName, " ").concat(r.reportNumber)
  }));

  // save the report selection in state to manage network reloads and changing reports
  const _useState = useState(value),
    _useState2 = _slicedToArray(_useState, 2),
    selectedReport = _useState2[0],
    setSelectedReport = _useState2[1];

  // load the available reports when component mounts
  useEffect(() => {
    serverFilter({
      job: [job],
      reportTypeIdentifier: reportType
    }, indexQuery, true);
  }, [job, reportType, indexQuery, serverFilter]);
  useEffect(() => () => {
    // clean up stale state when component unmounts
    showCancel();
    indexCancel();
  }, [indexCancel, showCancel]);

  // only change the active record once the remote report has loaded
  useEffect(() => {
    if (active && selectedReport && active.id === selectedReport.id) {
      onChange({
        path: thisPath,
        value: active
      });
    }
  }, [selectedReport, onChange, active, thisPath]);
  const handleChange = useCallback(_ref2 => {
    let path = _ref2.path,
      newSelection = _ref2.value;
    if (!newSelection) {
      // clear the selection
      onChange({
        path,
        value: newSelection
      });
    } else if (!selectedReport || newSelection.id !== selectedReport.id) {
      // the selected report has changed, get the details
      serverShow(newSelection.id);
    }
    setSelectedReport(newSelection);
  }, [selectedReport, onChange, serverShow]);
  return /*#__PURE__*/React.createElement(UncomposedSinglePickerField, {
    onChange: handleChange,
    options: reportsWithTitles,
    value: value,
    valueKey: "id",
    label: label,
    enabled: enabled,
    path: thisPath
  });
};
ReportPickerField.propTypes = {
  job: PropTypes.shape({
    id: PropTypes.string
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  reportReference: PropTypes.shape({
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({})),
    active: PropTypes.shape({
      id: PropTypes.string
    })
  }).isRequired,
  reportReferenceActions: PropTypes.shape({
    indexCancel: PropTypes.func,
    serverFilter: PropTypes.func,
    serverShow: PropTypes.func,
    showCancel: PropTypes.func
  }).isRequired,
  reportType: PropTypes.string.isRequired,
  thisPath: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  enabled: PropTypes.bool.isRequired,
  value: PropTypes.shape({})
};
export { ReportPickerField as UncomposedReportPickerField };
export default entityComposition(ReportPickerField, ['reportReference'], {
  job: state => state.report.active.Job,
  label: labelSelector,
  value: valueSelector,
  onChange: logValueOnChange,
  thisPath: newPathSelector,
  enabled: enabledSelector
});